/**
 * Created by Ning Jiang on 2021-07-01.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {TombstoneRip} from "../../TombstoneRip";
import {TombstoneRipGameMode} from "../../gameflow/TombstoneRipGameMode";
import {TimelineLite} from "gsap";
import {TombstoneRipSound} from "../../sound/TombstoneRipSound";
import {TombstoneRipBackground} from "../../view/TombstoneRipBackground";
import {IBetWayWinData} from "../../server/data/ITombstoneRipData";

export class SuperFsMLandingController extends ReelStopPresentationController {

    constructor() {
        super("SuperFsMToWildController");
    }

    protected onReelBounce(data:IReelStateEventData):Promise<any> {
        const gameData = TombstoneRip.model.parsedGameData;
        if(gameData.mode != TombstoneRipGameMode.FREESPIN_SUPER) {
            return Promise.resolve();
        }

        TombstoneRip.reels[data.reelId].reelView.allSymbols.forEach(sym => {
            sym.resetFire();
        });

        const tl = new TimelineLite();
        let playMulMSound = false;
        let playWildMSound = false;
        this.getSymIds(data.reelId).forEach(symId => {
            const sym = TombstoneRip.reels[data.reelId].getSymbol(symId);
            if(data.reelId === 4) {
                TombstoneRip.reels.forEach((reel, reelId) => {
                    if(reelId < 4) {
                        reel.superWildM = gameData.superFSInfo.outlawWild;
                    }
                });
                if(sym.symbolName.includes(gameData.superFSInfo.outlawMultiplier)) {
                    // When multiplier meets wild!
                    tl.add(TombstoneRip.superFsPop.playMatch());
                } else {
                    tl.add(() => {
                        TombstoneRip.reel5Frame.stopSuperSpin();
                        this.playLandingShake(4, 1.2);
                    });
                }
                TombstoneRipSound.fadeAndStopSound({
                    name : TombstoneRipSound.RESPIN_SPIN,
                    to : 0,
                    duration : 100
                });
            } else {
                if(sym.symbolName.includes(gameData.superFSInfo.outlawWild)) {
                    playWildMSound = true;
                    tl.add(sym.setWild(), 0);
                }
            }

            if(sym.symbolName.includes(gameData.superFSInfo.outlawMultiplier)) {
                if(data.reelId < 4) {
                    playMulMSound = true;
                }
                tl.add(sym.setMultiplier(gameData.superFSInfo.outlawMultiplierValue, true), 0);
            }
        });
        if(data.reelId === 4) {
            tl.add(() => TombstoneRip.superFsPop.moveToSide(), "+=0.5");
        }

        tl.add(() => {
            if(playMulMSound) {
                TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.SUPER_FS_MUL_M_LAND});
            }
            if(playWildMSound) {
                TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.SYMBOL_TO_WILD});
            }
            if(playWildMSound && playMulMSound && gameData.superFSInfo.outlawMultiplier === gameData.superFSInfo.outlawWild) {
                TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.SUPER_FS_M_FIRE_LAND});
            }
            if(data.reelId === 0 || data.reelId === 1) {
                tl.add(() => this.playLandingShake(data.reelId, 0.5), 0);
            }

            if(data.reelId === 2 && TombstoneRip.model.parsedGameData.currentWinRatioConfig!.ratio > 1) {
                tl.add(() => this.playLandingShake(data.reelId, 0.8), 0);
            }

            if(data.reelId === 3 && TombstoneRip.model.parsedGameData.currentWinRatioConfig!.ratio > 1 && this.reel3ContainsWin()) {
                tl.add(() => this.playLandingShake(data.reelId, 1), 0);
            }
        }, 0);

        if(tl.totalDuration() > 0) {
            return Promise.resolve(tl);
        } else {
            return Promise.resolve();
        }
    }

    private reel3ContainsWin():boolean {
        const betWins = TombstoneRip.model.parsedGameData.betWins;
        return betWins.length > 0 && betWins.some((w:IBetWayWinData) => w.length > 4);
    }

    private getSymIds(reelId:number):number[] {
        switch(reelId) {
            case 0:
                return [0, 1];
            case 4:
                return [0];
            default:
                return [0, 1, 2];
        }
    }

    private playLandingShake(reelId:number, factor?:number):void {
        TombstoneRipBackground.shakeStageOnce(factor);
        TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.SUPER_FS_REELS_LANDING[reelId]});
    }
}